<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
  >
    <a-switch
      :disabled="disabled"
      v-decorator="[ 
                    `${varName}`, 
                    {rules: [{ required: varRequired, type: 'boolean', message: message }], initialValue: varInitial
                    }]"
      :defaultChecked="varInitial"
      checkedChildren="Yes"
      unCheckedChildren="No"
    />
    <a-alert :message="description" type="info" showIcon style="margin-top:5px;" v-if="description" />
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: Boolean,
    varRequired: Boolean,
    formLayout: String,
    size: String,
    description: [String, null],
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    message() {
      return `Please enter ${this.varLabel.toLowerCase()}`;
    }
  }
};
</script>
